import React, { FC } from 'react';
import { Form } from '@ant-design/compatible';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';

const WOIsWarrantyFormField: FC<any> = ({ form, formData, disabled = false }) => {
	return (
		<Form.Item label="Under Warranty ?">
			{form.getFieldDecorator('isWarranty', {
				initialValue: formData.isWarranty ? 'true' : 'false',
			})(
				<OWRadioGroup
					valueAccessor={(item) => item.value}
					renderRecord={(item) => item.label}
					disabled={disabled}
					items={[
						{
							label: 'Yes',
							value: 'true',
						},
						{
							label: 'No',
							value: 'false',
						},
					]}
				/>
			)}
		</Form.Item>
	);
};

export default WOIsWarrantyFormField;
